import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { GlobalState } from "../../GlobalState";
import { DashboardSvg } from "../../assets/svg";
import DashboardSensorBoxV2 from "../sensor/DashboadSensorBoxV2";
import PumpStatusV2 from "../sensor/PumpStatusV2";
import PumpStatusV3 from "../sensor/PumpStatusV3";
import SolenoidBoxComponent from "../sensor/SolenoidBox";
import Banner from "../utils/banner";
import GatewayBoxComponent from "../sensor/gatwayDashboard";
import { Link } from "react-router-dom";
import SplashScreen from "../utils/SplashScreen";
import { syncFcmToken, getDeviceToken } from "../utils/deviceToken";

const Container = styled.div`
  margin: auto;
  width: 90%;
  position: relative;
  margin-top:0;
`;

const ContentContainer = styled.div``;

const SensorType = styled.h3`
  color: #107066;
  font-size: 1rem;
  font-weight: 700;
  margin: 0 0 0.15rem 0.2rem;
  padding: 0;
  width: 100%;
  text-align: left;
`;

const SensorWrapper = styled.div`
  border-radius: 20px;
  margin: 0.5rem 0;
  display: flex;
  width: fit-content;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  padding: 0.2rem;
  margin: 0 auto;
  gap: 0.5rem;
  @media (min-width: 61.313em) {
    max-width: 85%;
  }
`;

// const OuterBox = styled.div`
//   width: 100%;
//   background: #fafafa;
//   border-radius: 14px;
//   padding: 0.4rem 0.3rem;
//   box-shadow: 0 2px 10px rgba(0,0,0,0.08);
//   display: flex;
//   flex-wrap: wrap;
//   gap: 0px 10px;
//   justify-content: center;
// `;

const OuterBox = styled.div`
  width: 100%;
  background: #fafafa;
  border-radius: 14px;
  padding: 0.4rem 0.3rem;
  box-shadow: 0 2px 10px rgba(0,0,0,0.08);

  display: flex;
  flex-wrap: wrap;

  column-gap: 20px;   /* ✅ horizontal gap */
  row-gap: 4px;      /* optional */

  justify-content: center;
`;


const ContainerWrapper = styled.div`
  margin-bottom: 0.3rem;
`;

const BannerTitle = styled.span`
  color: #107066;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 100%;

  @media (max-width: 480px) {
    font-size: 0.85rem;
  }
`;

function getPumpLabel(sensors) {
  const hasPump = sensors.some(s => s.motor_id && !s.isBorewell);
  const hasBorewell = sensors.some(s => s.motor_id && s.isBorewell);

  if (hasPump && hasBorewell) return "Pump / Borewell";
  if (hasBorewell) return "Borewell";
  return "Pump";
}

export default function DashboardV2() {
  const state = useContext(GlobalState);
  const [loading, setLoading] = useState(true);
  const [sensorList, setSensorList] = useState([]);

  useEffect(() => {
    async function fetchData(token) {
      try {
        const sensor_list_res = await axios.get(
          `${process.env.REACT_APP_API}/user/v2/sensor_list`,
          { headers: { Authorization: token[0] } }
        );
        const sensor_list = sensor_list_res.data;

        const enrichedSensors = await Promise.all(
          sensor_list.map(async (item) => {
            const sensorsWithHydrosense = await Promise.all(
              item.sensors.map(async (sensor) => {
                if (sensor.motor_id && sensor.isBorewell) {
                  try {
                    const reading = await axios.get(
                      `${process.env.REACT_APP_API}/sensor/reading?sensor_id=${sensor.sensor_id}&type=water-sense`,
                      { headers: { Authorization: token[0] } }
                    );
                    if (reading.data && reading.data.name === "water-sense") {
                      return { ...sensor, isHydrosense: true };
                    }
                  } catch (err) {
                    console.log("No water-sense reading for sensor:", sensor.sensor_id);
                  }
                }
                return { ...sensor, isHydrosense: false };
              })
            );

            return { ...item, sensors: sensorsWithHydrosense };
          })
        );

        setSensorList(enrichedSensors);
        setLoading(false);
      } catch (err) {
        console.log(err);
        setLoading(false);
      }
    }

    fetchData(state.token);

    // Sync FCM token to server once on home page load.
    // Runs fire-and-forget — errors are intentionally swallowed.
    const pushFcmToken = async () => {
      try {
        const fcmToken = await syncFcmToken();
        const deviceId = getDeviceToken();
        if (fcmToken && deviceId) {
          const token = state.token[0];
          await axios.put(
            `${process.env.REACT_APP_API}/user/update_device_data`,
            { deviceId, fcmToken },
            { headers: { Authorization: token } }
          );
        }
      } catch (e) {
        // Silently ignore — FCM sync failure should not affect the dashboard
      }
    };
    pushFcmToken();
  }, [state.token]);

  if (loading) return <SplashScreen />;

  return (
    <Container>
      {/* <Link to="/profile">
        <Banner
          title={`Welcome ${state.userAPI.name}`}
          subtitle=""
          tooltip="View Your Profile"
        >
          
          <DashboardSvg />
        </Banner>
      </Link> */}

      <Link to="/profile">
  <Banner
    title={<BannerTitle>Welcome {state.userAPI.name}</BannerTitle>}
    subtitle=""
    tooltip="View Your Profile"
  >
    <DashboardSvg />
  </Banner>
</Link>

      <ContentContainer>
        {sensorList.map((items, idx) => {
          if (!items.sensors || items.sensors.length === 0) return null;

          return (
            <ContainerWrapper key={`container-${idx}`}>
              <SensorWrapper>
                <OuterBox>
                  {/* <SensorType>{items.label}</SensorType> */}
                   <SensorType>
                    {items.label === "Pump" ? getPumpLabel(items.sensors) : items.label}
                  </SensorType>                  
                  {items.sensors
                    .filter((s) => s?.type === "Gateway")
                    .map((sensor, idx) => (
                      <GatewayBoxComponent key={`gateway-${idx}`} sensor={sensor} />
                    ))}

                  {(() => {
                    const pumps = [];
                    const regularBorewells = [];
                    const hydrosenseBorewells = [];

                    items.sensors
                      .filter((s) => s?.motor_id)
                      .forEach((sensor) => {
                        if (!sensor.isBorewell) {
                          pumps.push(sensor);
                        } else if (sensor.isHydrosense) {
                          hydrosenseBorewells.push(sensor);
                        } else {
                          regularBorewells.push(sensor);
                        }
                      });

                    console.log("Pumps:", pumps.map((s) => s.location_name));
                    console.log("Regular Borewells:", regularBorewells.map((s) => s.location_name));
                    console.log("Hydrosense Borewells:", hydrosenseBorewells.map((s) => s.location_name));

                    return (
                      <>
                        {pumps.map((sensor, idx) => (
                          <PumpStatusV2
                            key={`p2-${idx}`}
                            motor_id={sensor.motor_id}
                            sensor_id={sensor.sensor_id}
                            isBorewell={sensor.isBorewell}
                          />
                        ))}
                        {regularBorewells.map((sensor, idx) => (
                          <PumpStatusV3
                            key={`p3-${idx}`}
                            motor_id={sensor.motor_id}
                            sensor_id={sensor.sensor_id}
                            isBorewell={sensor.isBorewell}
                          />
                        ))}
                      </>
                    );
                  })()}

                  {items.sensors
                    .filter((s) => !s?.motor_id && s?.type !== "Gateway")
                    .map((sensor, idx) => {
                      if (sensor?.type === "Solenoid Valve") {
                        return <SolenoidBoxComponent key={`sol-${idx}`} sensor={sensor} />;
                      }
                      return (
                        <DashboardSensorBoxV2
                          key={`s-${idx}`}
                          sensor_id={sensor.sensor_id}
                          type={sensor.type}
                        />
                      );
                    })}

                  {(() => {
                    const hydrosenseBorewells = items.sensors
                      .filter((s) => s?.motor_id && s.isBorewell && s.isHydrosense);

                    if (hydrosenseBorewells.length > 0) {
                      return (
                        <>
                          <div style={{ flexBasis: "100%", height: 0 }} />
                          {hydrosenseBorewells.map((sensor, idx) => (
                            <PumpStatusV3
                              key={`p3-hs-${idx}`}
                              motor_id={sensor.motor_id}
                              sensor_id={sensor.sensor_id}
                              isBorewell={sensor.isBorewell}
                            />
                          ))}
                        </>
                      );
                    }
                    return null;
                  })()}
                </OuterBox>
              </SensorWrapper>
            </ContainerWrapper>
          );
        })}
      </ContentContainer>
    </Container>
  );
}